/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const LoadIcon = ({ width = 9, height = 14, color = '#f7f9fA', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 9 14' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.5 0.666504C0.5 0.390362 0.723858 0.166504 1 0.166504C5.32623 0.166504 8.83333 3.67361 8.83333 7.99984C8.83333 10.2444 7.8886 12.2692 6.37649 13.6967C6.17569 13.8863 5.85924 13.8772 5.66968 13.6764C5.48011 13.4756 5.48921 13.1592 5.69001 12.9696C7.01036 11.7231 7.83333 9.95798 7.83333 7.99984C7.83333 4.22589 4.77395 1.1665 1 1.1665C0.723858 1.1665 0.5 0.942646 0.5 0.666504Z'
    />
  </svg>
);

export default LoadIcon;
